module.exports = __webpack_public_path__ + "static/media/parking3.5db6bd4a.jpg";